<template>

    <edit-form
        :title="title"
        :subTitle="subTitle"
        :schema="schema"
        storeNamespace="services"
        objectNamespace="O_method"
        :objectId="id"
        :listOnSave="listOnSave"
    >

    </edit-form>

</template>

<script>
import EditForm from '@/components/form/EditForm'

export default {
    name: "ServiceMethodForm",
    components: {
        EditForm,
    },
    props: {
        id: {
            type: String
        },
        listOnSave: {
            type: Boolean,
            default: false 
        },
    },
    computed: {
       schema() {
            const filter = {
                name: '{ type:"input", rules:"required" }',
                uncertainty: '{ type:"input", rules:"required|numeric|min_value^:0", inputType:"number" }',
                description: '{ type:"textarea"}',
                
            }
            
            return this.$helpers.schemaParser(filter)
        },
        title() {
            return this.id ? "Update method" : "New method";
        },
        subTitle() {
            return this.id ? "Here you can edit a method" : "Here you can create a new method";
        },
        
    },
}
</script>

<style>

</style>